module.exports = __webpack_public_path__ + "static/media/therapist-mobile-cover.58fabc9f.png";